<script lang="ts">
    import cn from '$common/utils/cn';
    import VerticalFiltersContent from '$saga/views/Search/components/verticalFilters/VerticalFiltersContent.svelte';
    import { filtersContext } from '$saga/views/Search/store';
    import type { FilterType } from '$saga/views/Search/types';

    // ab test
    export let openAccordions: boolean;
    export let handleSelectedFilter: (filterType: FilterType) => void;

    // Watch for changes in hideVerticalBar to adjust layout
    $: {
        const searchEngineSection = document.getElementById(
            'search-engine-section',
        );
        const searchAdminSection = document.getElementById(
            'search-admin-section',
        );
        const adminLandingFilterButton = document.getElementById(
            'admin-landing-filter',
        );

        if ($filtersContext.hideVerticalBar) {
            searchEngineSection?.classList.remove('desktop:gap-2xl', 'gap-2xl');
            document
                .getElementById('result-cards')
                ?.classList.add('desktop:grid-cols-4');
            document
                .getElementById('result-cards')
                ?.classList.remove('desktop:grid-cols-3');
            searchAdminSection?.classList.add('desktop:hidden');
            adminLandingFilterButton?.classList.add('hidden');
        } else {
            searchEngineSection?.classList.remove('gap-2xl');
            searchEngineSection?.classList.add('desktop:gap-2xl');
            document
                .getElementById('result-cards')
                ?.classList.remove('desktop:grid-cols-4');
            document
                .getElementById('result-cards')
                ?.classList.add('desktop:grid-cols-3');
            searchAdminSection?.classList.remove('desktop:hidden');
            adminLandingFilterButton?.classList.remove('hidden');
        }
    }
</script>

<div
    class={cn(
        'hidden desktop:block h-fit w-full min-w-[300px] max-w-[300px] border border-t-0 rounded-b-m border-solid border-border-quiet bg-white px-s transition-all',
        $filtersContext.hideVerticalBar && 'hidden',
    )}
>
    <div class="flex flex-col gap-m py-m">
        <VerticalFiltersContent {openAccordions} {handleSelectedFilter} />
    </div>
</div>
